module.exports = __webpack_public_path__ + "img/团队默认头像.08740929.png";